import React, {Suspense, lazy} from 'react'
import {Provider} from 'react-redux'
import {MuiThemeProvider, CssBaseline} from '@material-ui/core'
import {IntlProvider} from 'react-intl'
import {Router, Route, Switch} from 'react-router-dom'

import store from './stateManagement/store'
import theme from './theme'
import GlobalStyles from './components/containers/GlobalStyles'
import * as serviceWorker from './serviceWorker'
import Page404 from 'pages/404/Page404'
import CacheBuster from './components/containers/CacheBuster'
import history from 'core/services/history'
import {messages, languageWithoutRegionCode} from 'utils/localizer'
import NotistackProvider from 'components/containers/notiStack/NotistackProvider'

const LoggedInComponent = lazy(() => import('./routes/loggedIn/Main'))

const LoggedOutComponent = lazy(() => import('./routes/loggedOut/Main'))

function App() {
  return (
    <CacheBuster>
      {({loading, isLatestVersion, refreshCacheAndReload}) => {
        if (loading) {
          return null
        }
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload()
        }
        return (
          <Provider store={store}>
            <IntlProvider
              locale={languageWithoutRegionCode}
              defaultLocale="es"
              messages={messages}
            >
              <Router history={history}>
                <MuiThemeProvider theme={theme}>
                  <NotistackProvider>
                    <CssBaseline />
                    <GlobalStyles />
                    <Suspense fallback={<div />}>
                      <Switch>
                        <Route path="/secure">
                          <LoggedInComponent />
                        </Route>
                        <Route>
                          <LoggedOutComponent />
                        </Route>
                        <Route path="*" exact component={Page404} />
                      </Switch>
                    </Suspense>
                  </NotistackProvider>
                </MuiThemeProvider>
              </Router>
            </IntlProvider>
          </Provider>
        )
      }}
    </CacheBuster>
  )
}

serviceWorker.register()

export default App
